/**
 * Block dependencies.
 */
import classnames from "classnames"
import twitterIcon from "./icon"
import Settings from "./settings";
import "./editor.scss"
/**
 * Block libraries
 */

const { __ } = wp.i18n;
const { Fragment } = wp.element;
const {
	InspectorControls,
	BlockControls,
	BlockAlignmentToolbar,
	RichText
} = wp.editor;
const { registerBlockType } = wp.blocks;

export default registerBlockType("ssb/click-to-tweet", {
	title: __("Click to Tweet"),
	description: __(
		"SSB Click to tweet easy way to tweet your content."
	),
	category: "common",
	icon: twitterIcon,
	keywords: [__("twiter"), __("clicktotweet"), __("ssb")],
	attributes: {
		theme: {
			type: "string",
			default: "twitter-round"
		},
		tweet: {
			type: "string",
			default: ""
		},
		front: {
			type: "string",
			default: ""
		},
		IncludePageLink: {
			type: "boolean",
			default: true
		},
		IncludeVia: {
			type: "boolean",
			default: true
		},
		showTweetButton: {
			type: "boolean",
			default: true
		},
		align: {
			type: "string",
			default: ""
		},
	},
	supports: {
		// Turn off ability to edit HTML of block content.
		html: false,
		// Turn off reusable block feature.
		reusable: false

	},
	getEditWrapperProps({ align }) {
		if ("center" === align || "wide" === align || "full" === align) {
			return { "data-align": align };
		}
	},
	edit: props => {

		const { attributes: { front, theme, align, showTweetButton }, className, setAttributes } = props
		const mainClasses = classnames(
			className,
			"ssb-ctt-wrapper",
			{ [`${theme}`]: theme },
			{ [`align${align}`]: align },
			{ [`hide-button`]: !showTweetButton },
		);
		return (
			<Fragment>
				<BlockControls>
					<BlockAlignmentToolbar
						value={align}
						onChange={align => setAttributes({ align })}
						controls={["center", "wide", "full"]}
					/>
				</BlockControls>
				<InspectorControls>

					<Settings {...props} />

				</InspectorControls>
				<div class={mainClasses} data-theme="twitter-round">
					<div class="ssb-ctt">
						<RichText
							tabName={'div'}
							className={"ssb-ctt-text"}
							value={front}
							onChange={front => setAttributes({ front })}
							placeholder={__('Enter your content ...')}
							keepPlaceholderOnFocus
						/>

						{showTweetButton &&
							<span class="ssb-ctt-btn">
								Click to tweet
                {twitterIcon}
							</span>
						}
					</div>
				</div>
			</Fragment>)
	},
	save: props => {
		return null;
	}
});



// WEBPACK FOOTER //
// blocks/click-to-tweet/index.js